import { DAP } from "@gen/dap/v1/dap_pb";
import { useOutletContext } from "react-router";

interface DAPContext {
  dap: DAP;
  isLoading: boolean;
  errorDapMessage: string | undefined;
}

export function useDAP() {
  return useOutletContext<DAPContext>();
}
